'use strict';

const { getDependencyClass } = require('../../../lib/dependencies.js');

module.exports = getDependencyClass('phoenix-page').then((pageClass) => {
    class PhoenixTabPanel extends pageClass.PhoenixElement {
        get observedBroadcastedEvents() {
            return ['phoenix:tab:active'];
        }

        set activeState(val) {
            this.setAttribute('aria-hidden', !val);
            this.hidden = !val;
        }

        connectedCallback() {
            super.connectedCallback();
            const phoenixTabs = this.closest('phoenix-tabs');
            this.tabsId = phoenixTabs && phoenixTabs.id;
            this.id = `${this.tabsId}-${this.id}`;
            if (phoenixTabs.activeTabId && phoenixTabs.hashEnabled) {
                this.activeState = this.id === phoenixTabs.activeTabId;
            }
        }

        broadcastedEventCallback(name, args = {}) {
            const tabsId = args.detail && args.detail.tabsId;
            const panelId = args.detail && args.detail.panelId;

            if (tabsId !== this.tabsId) {
                return;
            }

            switch (name) {
                case 'phoenix:tab:active':
                    this.activeState = this.id === panelId;
                    break;
            }
        }
    }

    window.customElements.whenDefined('phoenix-tabs').then(() => {
        window.customElements.define('phoenix-tab-panel', PhoenixTabPanel);
    });
});
